<template>
	<div class="item-grafic-os">
		<div class="tarefa" :style="tarefaStyle"></div>
		div
	</div>
</template>
<script>
	import { timeNomalize } from './tools.js';

	export default {
		props: ['data', 'init'],
		computed: {
			tarefaStyle() {
				return {
					left: `${this.data.date.pInit - this.init}px`,
					width: `${this.data.date.pTerm - this.data.date.pInit}px`,
				};
			},
		},
	};
</script>
<style scoped>
	.tarefa {
		background: #2196f3;
		height: 11px;
		position: absolute;
		top: 19px;
	}
	.item-grafic-os {
		display: block;
		width: 100%;
		height: 38px;
		border-top: 1px solid #cecece;
		position: relative;
	}
</style>



// WEBPACK FOOTER //
// src/components/order-of-service/components/GraficMode/components/grafic-os.vue